import { InstitucionSnp, SedeSnp } from '@/shared/model/snp/instituciones-snp.model';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BuscadorInstitucionSnpComponent extends Vue {
  @Prop({ required: true })
  public readonly institucion: InstitucionSnp;

  @Prop({ required: false, default: false })
  public seleccionarSoloInstitucion: boolean;

  @Prop({ required: false, default: false })
  public ocultarSedes: boolean;

  public totalRows = 0;
  public currentPage = 1;
  public perPage = 15;

  public readonly fieldsSedes: BvTableFieldArray = [
    {
      key: 'claveSede',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.claveSede').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'sede',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.sede').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'claveDependencia',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.claveDependencia').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'nombreDependencia',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.dependencia').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'pais',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.pais').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'entidadFederativa',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.entidadFederativa').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'activo',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.activo').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.buscadorInstitucionesSnp.card.acciones').toString(),
      class: 'text-center btn-acciones',
      thStyle: { width: '7rem' },
    },
  ];

  public seleccionarConSede(sede: SedeSnp): void {
    this.emitirSeleccion(sede);
  }

  public seleccionarSinSede(): void {
    this.emitirSeleccion(undefined);
  }

  @Emit('selected')
  public emitirSeleccion(sede: SedeSnp): InstitucionSnp {
    const seleccion = InstitucionSnp.fromObject(this.institucion);
    if (sede) {
      seleccion.sedes = [SedeSnp.fromObject(sede)];
    } else {
      seleccion.sedes = [];
    }

    return seleccion;
  }
}
